import React, { useEffect, useState } from 'react';
import RankedBars from './RankedBars';
import { get } from '../../../../Services/http';
import { fmt } from '../format';
import { cardStyle } from '../styles';

const TOP_COUNT = 20;

// Articles that are out of stock and monitored by customers, the most monitored first
const MonitoredArticles = () => {
    const [articles, setArticles] = useState(null);
    const [error, setError] = useState(null);
    const [expanded, setExpanded] = useState(null);

    // Uses the shared http service, it sends the request context that the server needs to resolve the channel for the product urls
    useEffect(() => {
        let cancelled = false;

        get('/api/sales-data/monitored-articles')
            .then((res) => res.json())
            .then((data) => { if (!cancelled) setArticles(data); })
            .catch((err) => { if (!cancelled) setError(err.message); });

        return () => { cancelled = true; };
    }, []);

    const rows = (articles || []).slice(0, TOP_COUNT);

    return (
        <div style={{ ...cardStyle, padding: '1rem' }}>
            <strong>Bevakade artiklar slut i lager</strong>
            <div style={{ fontSize: '0.75rem', color: '#777', margin: '0.25rem 0 0.75rem' }}>
                Artiklar som just nu &auml;r slut i lager, sorterade efter antal bevakningar. Klicka p&aring; antalet f&ouml;r att visa e-postadresserna.
            </div>
            {error && <div style={{ fontSize: '0.85rem', color: '#cc4b37' }}>Kunde inte h&auml;mta bevakade artiklar: {error}</div>}
            {!error && articles === null && <div style={{ fontSize: '0.85rem', color: '#777' }}>Laddar...</div>}
            {!error && articles !== null && rows.length === 0 && <div style={{ fontSize: '0.85rem', color: '#777' }}>Inga bevakade artiklar &auml;r slut i lager.</div>}
            <RankedBars
                rows={rows.map((row) => ({
                    key: row.articleNumber,
                    label: row.name || row.articleNumber,
                    sublabel: row.articleNumber,
                    value: row.count,
                    valueLabel: `${fmt(row.count)} st`,
                    href: row.url,
                    onValueClick: () => setExpanded(expanded === row.articleNumber ? null : row.articleNumber),
                    details: expanded === row.articleNumber && (
                        <div style={{ margin: '0 0 0.5rem 2.25rem', padding: '0.5rem 0.75rem', backgroundColor: '#f6f8fa', borderRadius: '0.25rem', fontSize: '0.8rem' }}>
                            {row.emails.map((email) => <div key={email}>{email}</div>)}
                        </div>
                    ),
                }))}
            />
        </div>
    );
};

export default MonitoredArticles;
